import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject, singleton } from "aurelia-framework";
import { IIdgNoteSignalrResponse } from "../interfaces/i-idg-note-signalr";
import { IJoinMeetingSignalrResponse } from "../interfaces/i-meeting-signalr";
import { IReportSignalrResponse } from "../interfaces/reports/i-report-notification";

export const enum SignalrEvent {
    NewMessage = "message:new",
    MeetingStarted = "meeting:started",
    MeetingEnded = "meeting:ended",
    JoinMeeting = "meeting:userJoined",
    IdgNoteReviewed = "idgnote:reviewed",
    IdgNoteUnreviewed = "idgnote:unreviewed",
    ReportNotification = "report:notification",
    TaskDetailsUpdated = "taskdetails:updated",
}

const enum SignalrServerEvent {
    Notify = "notify",
    StartMeeting = "startMeeting",
    JoinMeeting = "joinMeeting",
    EndMeeting = "endMeeting",
    IdgNoteReviewed = "idgNoteReviewed",
    IdgNoteUnreviewed = "idgNoteUnreviewed",
    ReportNotification = "exportGenerated",
    TaskDetailsUpdated = "taskDetailsUpdated"
}

@autoinject()
@singleton()
export class HubsContainer {
    private _eventAggregator: EventAggregator;
    public hubs: Map<string, Map<string, () => void>> = new Map<string, Map<string, () => void>>();

    public constructor(ea: EventAggregator) {
        this._eventAggregator = ea;
        this.hubs.set("notificationHub", this.createNotificationHub());
        // TODO: Decide on Hubs Architecture
        // this.hubs.set("MessageHub", this.createMessageHub());
    }

    /* public createMessageHub() {

        let messageHub = new Map<string, (...args: string[]) => void>([
            ["messageReceived", (conversationId: string): void => {
                this._EventAggregator.publish("message:received", { conversationId });
            }]
        ]);

        return messageHub;
    } */

    public createNotificationHub() {

        // TODO: Hubs separation will get rid of the any usage here
        let notificationHub = new Map<string, (...args: any) => void>([
            [
                SignalrServerEvent.Notify,
                (conversationId: string): void => {
                    this._eventAggregator.publish(SignalrEvent.NewMessage, conversationId);
                }
            ],
            [
                SignalrServerEvent.StartMeeting,
                (meetingId: string): void => {
                    this._eventAggregator.publish(SignalrEvent.MeetingStarted, meetingId);
                }
            ],
            [
                SignalrServerEvent.JoinMeeting,
                (message: IJoinMeetingSignalrResponse): void => {
                    this._eventAggregator.publish(SignalrEvent.JoinMeeting, message);
                }
            ],
            [
                SignalrServerEvent.EndMeeting,
                (meetingId: string): void => {
                    this._eventAggregator.publish(SignalrEvent.MeetingEnded, meetingId);
                }
            ],
            [
                SignalrServerEvent.IdgNoteReviewed,
                (message: IIdgNoteSignalrResponse): void => {
                    this._eventAggregator.publish(SignalrEvent.IdgNoteReviewed, message);
                }
            ],
            [
                SignalrServerEvent.IdgNoteUnreviewed,
                (message: IIdgNoteSignalrResponse): void => {
                    this._eventAggregator.publish(SignalrEvent.IdgNoteUnreviewed, message);
                }
            ],
            [
                SignalrServerEvent.ReportNotification,
                (message: IReportSignalrResponse): void => {
                    this._eventAggregator.publish(SignalrEvent.ReportNotification, message);
                }
            ],
            [
                SignalrServerEvent.TaskDetailsUpdated,
                 (patientId: string): void => {
                    this._eventAggregator.publish(SignalrEvent.TaskDetailsUpdated, patientId);
                }
            ]
        ]);
        return notificationHub;
    }
}
